import React, { useContext, useState } from 'react'
import DefaultLayout from '../layouts/DefaultLayout'
import AuthLayout from '../layouts/AuthLayout'
import { useLocation } from 'react-router-dom'
import { AuthContext } from '../context/authContext'
import { routes } from '../routes'

export default function Layout ({ children }) {
  const { loading, currentUser: user } = useContext(AuthContext)
  const location = useLocation()
  const Layouts = [DefaultLayout, AuthLayout]
  const [Layout, setLayout] = useState(0)
  const [noLayout, setNoLayout] = useState(false)
  const CurrentLayout = Layouts[Layout]

  React.useEffect(() => {
    const foundRoute = routes.find(item => item.path === location.pathname)
    // Check for routes that should have no layout (fullscreen pages like voice room)
    if (foundRoute?.layout === 'none') {
      setNoLayout(true)
    } else {
      setNoLayout(false)
      setLayout(
        foundRoute?.layout === 'auth' || loading ? 1 : !foundRoute ? 0 : 0
      )
    }
  }, [location, loading, user])

  // For fullscreen routes with no layout, just return children
  if (noLayout) {
    return <>{children}</>
  }

  return <CurrentLayout>{children}</CurrentLayout>
}
